import { urlApiQuizAnswersExport } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { IBodyStartQuizAnswersExport, IQuizAnswersExportJobResponse } from '~/utils/interface/quizAnswersExport';

// The export button shows its own messages, so these calls skip the global error toast.
export const quizAnswersExportApi = {
  startQuizAnswersExport(body: IBodyStartQuizAnswersExport) {
    const url = `${urlApiQuizAnswersExport.base}`;
    return axiosClient.post<IBaseResponse<IQuizAnswersExportJobResponse>>(url, body, { skipErrorToast: true });
  },

  getCurrentQuizAnswersExport() {
    const url = `${urlApiQuizAnswersExport.current}`;
    return axiosClient.get<IBaseResponse<IQuizAnswersExportJobResponse>>(url, { skipErrorToast: true });
  },

  downloadQuizAnswersExportFile(jobId: string) {
    const url = `${urlApiQuizAnswersExport.file(jobId)}`;
    return axiosClient.get<Blob>(url, { responseType: 'blob' });
  },
};
